export const apps = [ // Ce qui est en haut à gauche dans le dropdown
    {
        name: "Ma société",
        route: "/company/informations",
        id: "COMPANY",
    },
    {
        name: "Plannings & absences",
        route: "/dashboard",
        id: "PLANNING",
    },
    {
        name: "Notes de frais",
        route: "/notes-de-frais/notes",
        id: "NOTES",
    },
    {
        name: "Gestion des manifestations",
        route: "/manifestation/manifestations",
        id: "MANIFESTATION",
    },
    {
        name: "Gestion des activités",
        route: "/activity/projets",
        id: "ACTIVITY",
    },

    {
        name: "Gestion des interventions",
        route: "/task/planning",
        id: "TASK",
    },

    // { name: "Gestion des inventaires", route: "/inventaires", id: "inventory" }, // matériel technique et des costumes,
    // { name: "Gestion des interventions", route: "/interventions", id: "interventions" },

    // Mes interventions
    // Calendrier
    // Liste des interventions
    // Interventions : Nom, priorité, deadline, pôle, technicien, début d'intervention, fin d'intervention, is_finish, mail_donneur_dordre
    // 500e + 210€/an maintenance.

    /*  1. pool des taches créés par 4 donneurs d'ordre (avec priorité + deadline) / une tâche est liée à un pôle. => Avec commentaire
        2. les techniciens (x3) se les affectent et les positionnent dans leur planning
        3. éventuellement mise à jour de la durée effectuée (par le tech)
        4. export des tâches effectuées / par pôle / par tech / avec total
        5. délai entre création de la tâche et son application
        6. planning des tâches avec couleur par pôle / par technicien / couleur priorité
        7. le technicien valide la fin de tâche + envoi d'un mail au donneur d'ordre. Une fois validée la tâche est en lecture seule pour les tech. => Avec commentaire
        -> afficher les tâches non effectuées et passées.
        8. (opt.) envoi d'un mail avec le planning (envoyé aux donneurs d'ordre) 
*/

    //  Gestion des productions
    {
        name: "Gestion des talents",
        route: "/talents/dashboard",
        id: "TALENT",
    },
];

export const Menu = { // Menu de gauche
    NOTES: [
        {
            id: "NOTES_MANAGE",
            title: "Gestion des notes",
            to: "/notes-de-frais/gestion",
            isSubMenu: false,
            svg: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6",
        },
        {
            id: "NOTES_MY",
            title: "Mes notes de frais",
            to: "/notes-de-frais/notes",
            isSubMenu: false,
            svg: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6",
        },
    ],
    COMPANY: [
        {
            id: "COMPANY_MENU",
            title: "Ma société",
            to: "/company/informations",
            link: ["/company/socio-professional", "/company/informations", "/company/counters", "/company/time", "/company/settings"], // Pour dire dans quel menu on est
            isSubMenu: true,
            // svg: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6",
            svg: "m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25",
        },
        {
            id: "EMPLOYEES",
            title: "Gestion du personnel",
            to: "/team",
            isSubMenu: false,
            // svg: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z",
            svg: "M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z",
        },
        {
            id: "RIGHTS_MANAGEMENT",
            title: "Gestion des droits",
            to: "/company/profil",
            isSubMenu: false,
            // svg: "M12 17a2 2 0 100-4 2 2 0 000 4zm6-7V7a6 6 0 00-12 0v3H4v10h16V10h-2zm-2 0H8V7a4 4 0 118 0v3z",
            svg: "M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z",

        },
        {
            id: "SUBSCRIPTION",
            title: "Abonnement",
            isSubMenu: false,
            to: "/company/abonnement",
            // svg: "M4 4h16v4H4V4zm0 6h16v10H4V10zm2 4h4v2H6v-2z",
            svg: "M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z",
        },
        {
            id: "EXPORTS",
            title: "Exports",
            isSubMenu: false,
            to: "/company/exports",
            // svg: "M12 16V4M8 8l4-4 4 4M4 20h16",
            svg: "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m6.75 12-3-3m0 0-3 3m3-3v6m-1.5-15H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z",
        },
    ],
    MANIFESTATION: [
        {
            id: "MY_EVENTS",
            title: "Mes manifestations",
            to: "/manifestation/manifestations",
            isSubMenu: false,
            svg: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z",
        },
        {
            id: "MY_ENROLLMENTS",
            title: "Mes participations",
            isSubMenu: false,
            to: "/manifestation/participations",
            svg: <svg
                fill="#000000"
                version="1.1"
                id="Layer_1"
                className="shrink-0 mr-4 w-6 h-6"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 24 24"
                xmlSpace="preserve"
            >
                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                <g
                    id="SVGRepo_tracerCarrier"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                    <style type="text/css">{`.st0{fill:none;}`}</style>
                    <path d="M6,2v2H5C3.9,4,3,4.9,3,6v14c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V6c0-1.1-0.9-2-2-2h-1V2h-2v2H8V2H6z M5,9h14v11H5V9z"></path>
                    <rect y="0" className="st0" width="24" height="24"></rect>
                    <polygon points="16.4,12 12.4,16.2 10.5,14.4 9.3,15.6 11.8,18 12.4,18.7 13,18 17.6,13.2 "></polygon>
                </g>
            </svg>,
        },
        // {
        //     id: "MY_CAMPAIGN",
        //     title: "Mes campagnes",
        //     isSubMenu: false,
        //     to: "/manifestation/campagnes",
        //     svg: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z",
        // },
    ],
    TALENT: [
        {
            id: "TALENT_DASHBOARD",
            title: "Dashboard",
            to: "/talents/dashboard",
            isSubMenu: false,
            svg: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6",
        },
        {
            id: "TALENT_COLLABORATEURS",
            title: "Collaborateurs",
            to: "/talents/collaborateurs",
            isSubMenu: false,
            svg: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6",
        },
        {
            id: "TALENT_RECRUTEMENT",
            title: "Recrutement",
            to: "/talents/recrutement",
            isSubMenu: false,
            svg: "M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z",
        },
        {
            id: "TALENT_ENTRETIENS",
            title: "Entretiens",
            to: "/talents/entretiens",
            isSubMenu: false,
            svg: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6",
        },
        {
            id: "TALENT_FORMATIONS",
            title: "Formations",
            to: "/talents/formations",
            isSubMenu: false,
            svg: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6",
        },
    ],
    PLANNING: [
        {
            id: "DASHBOARD_MENU",
            title: "Dashboard",
            to: "/dashboard",
            isSubMenu: false,
            svg: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6",
        },
        {
            id: "PLANNING_MENU",
            title: "Plannings",
            to: "/planning",
            isSubMenu: false,
            svg: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z",
        },
        {
            id: "DEMAND_VALIDATION",
            title: "Demandes et validations",
            to: "/validation",
            isSubMenu: false,
            svg: "M9 12l2 2 4-4M5 4h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V6a2 2 0 012-2z",
            separator: true,
        },
        {
            id: "DAILY_FOLLOW_UP",
            title: "Suivi quotidien",
            to: "/daily_follow_up",
            isSubMenu: false,
            svg: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z",
        },
    ],
    ACTIVITY: [
        {
            id: "EVENTS",
            title: "Manifestations",
            to: "/activity/projets",
            isSubMenu: false,
            svg: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6",
        },
        {
            id: "SPACES",
            title: "Vos espaces",
            to: "/activity/espaces",
            isSubMenu: false,
            svg: "M6 4h12a2 2 0 012 2v12a2 2 0 01-2 2H6a1 1 0 01-1-1V5a1 1 0 011-1zm2 4h8M8 10h8M8 12h5",
        },
        {
            id: "MATERIALS",
            title: "Inventaires et matériels",
            isSubMenu: false,
            to: "/activity/inventaires",
            svg: "M6 4h12a2 2 0 012 2v12a2 2 0 01-2 2H6a1 1 0 01-1-1V5a1 1 0 011-1zm2 4h8M8 10h8M8 12h5",
        },
        {
            id: "DIRECTORY",
            title: "Annuaire",
            isSubMenu: false,
            to: "/activity/contacts",
            svg: "M6 4h12a2 2 0 012 2v12a2 2 0 01-2 2H6a1 1 0 01-1-1V5a1 1 0 011-1zm2 4h8M8 10h8M8 12h5",
        },
        {
            id: "PLANNING",
            title: "Plannings",
            isSubMenu: false,
            to: "/activity/planning",
            svg: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z",
        },
    ],
    TASK: [
        {
            id: "TASK_LIST",
            title: "Liste des interventions",
            to: "/intervention/list",
            isSubMenu: false,
            svg: <svg className="shrink-0 mr-4 w-6 h-6 size-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 12h16.5m-16.5 3.75h16.5M3.75 19.5h16.5M5.625 4.5h12.75a1.875 1.875 0 0 1 0 3.75H5.625a1.875 1.875 0 0 1 0-3.75Z" />
            </svg>
        },
        {
            id: "TASK_PLANNING",
            title: "Planning",
            isSubMenu: false,
            to: "/intervention/planning",
            svg: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z",
        },
        {
            id: "TASK_EXPORT",
            title: "Statistiques",
            isSubMenu: false,
            to: "/intervention/stats",
            svg: <svg className="shrink-0 mr-4 w-6 h-6 size-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 0 1 3 19.875v-6.75ZM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V8.625ZM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V4.125Z" />
            </svg >
        },
    ],
};





export const subMenu = [{ // Correspond aux tabs du haut
    id: "COMPANY",
    page: "COMPANY_MENU",
    title: "Ma société",
    to: "/company/informations",
    svg: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6",
},
{
    id: "CATEGORIES",
    page: "COMPANY_MENU",
    title: "Professions et catégories",
    to: "/company/socio-professional",
    svg: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z",
},
{
    id: "COUNTERS",
    page: "COMPANY_MENU",
    title: "Compteurs",
    to: "/company/counters",
    svg: "M6 12h4m2 0h4m-6 4h4m2 0h4M6 8h4M10 8h4M14 8h4",
},
{
    id: "HOURS",
    page: "COMPANY_MENU",
    title: "Gestion des horaires",
    to: "/company/time",
    svg: "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 4v6h6",
},
{
    id: "SETTINGS",
    page: "COMPANY_MENU",
    title: "Paramétrage",
    to: "/company/settings",
    svg: "M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z M15 12a3 3 0 11-6 0 3 3 0 016 0z",
},
{
    id: "INFOS",
    page: "EMPLOYEES",
    title: "Informations",
    to: "#informations",
    svg: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6",
},
{
    id: "ORGANISATION",
    page: "EMPLOYEES",
    title: "Affectations",
    to: "#organisation",
    svg: "M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4",
},
{
    id: "CONTRACTS_USER",
    page: "EMPLOYEES",
    title: "Contrats",
    to: "#contrats",
    svg: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z",
},
{
    id: "COUNTERS_USER",
    page: "EMPLOYEES",
    title: "Compteurs",
    to: "#compteurs",
    svg: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z",
},
{
    id: "PARAMETRES",
    page: "EMPLOYEES",
    title: "Paramètres",
    to: "#parametres",
    svg: "M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z",
},
{
    id: "CHECKING_RULES",
    page: "EMPLOYEES",
    title: "Pointage",
    to: "#pointage",
    svg: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z",
},
{
    id: "OPERATIONS",
    page: "EMPLOYEES",
    title: "Opérations",
    to: "#operations",
    svg: "M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z M15 12a3 3 0 11-6 0 3 3 0 016 0z",
},
{
    id: "INDEX_EVENTS",
    page: "EVENTS",
    title: "Page évènements",
    to: "/manifestation/manifestations",
},
];

/**
 * Premier onglet défini dans subMenu (ordre d’affichage) pour lequel l’utilisateur a access.
 * Évite Object.entries(sub_menu) dont l’ordre des clés ne suit pas l’UI ni les droits métiers.
 */
export function getFirstAccessibleSubMenuDefinition(menuPageId, subMenuRights) {
    if (!subMenuRights || typeof subMenuRights !== "object") {
        return null;
    }
    for (const def of subMenu) {
        if (def.page !== menuPageId) {
            continue;
        }
        if (subMenuRights[def.id]?.access) {
            return def;
        }
    }
    return null;
}

export const defaultRightName = {
    COMPANY: "Ma société",
    ACTIVITY: "Gestion d'activité",
    MANIFESTATION: "Gestion des manifestations",
    CATEGORIES: "Professions et catégories",
    COUNTERS: "Compteurs",
    HOURS: "Gestion des horaires",
    SETTINGS: "Paramétrage",
    EMPLOYEES: "Accès menu 'Gestion du personnel'",
    RIGHTS_MANAGEMENT: "Accès menu 'Gestion des droits'",
    COMPANY_MENU: "Accès menu 'Ma société'",
    SUBSCRIPTION: "Accès menu 'Abonnement'",
    EXPORTS: "Accès menu 'Export'",
    manage_export_profiles: "Gérer les profils d'export",
    run_payroll_export: "Lancer un export paie",
    LIST: "Liste",
    MAIN: "Accès à la page",
    MY_ENROLLMENTS: "Accès menu 'Mes évènements'",
    MY_EVENTS: "Accès menu 'Mes participations'",
    EVENTS: "Accès au menu 'EVENT'",
    INFOS: "Information du salarié",
    INFO_RIGHT: "Information des profils",
    INFO_SUBSCRIPTION: "Information abonnement",
    EXPORT_MENU: "Information export",
    ORGANISATION: "Onglet 'Affectations'",
    CONTRACTS_USER: "Onglet 'Contrats'",
    COUNTERS_USER: "Onglet 'Compteurs'",
    PARAMETRES: "Onglet 'Paramètres'",
    CHECKING_RULES: "Onglet 'Pointage'",
    OPERATIONS: "Onglet 'Opérations'",

    // Functions
    add_project: "Ajouter un projet",
    add_service: "Ajouter un service",
    add_pointing_device: "Ajouter un appareil de pointage",
    add_day_off: "Ajouter un jour férié",
    add_establishment: "Ajouter un établissement",
    add_category: "Ajouter une catégorie",
    add_counter: "Ajouter un compteur",
    add_hour_type: "Ajouter un type d’horaire",
    add_day_model: "Ajouter un modèle de journée",
    add_cycle: "Ajouter un cycle",
    manage_hour_limit_rules: "Gérer les règles de limites d'heures",
    add_employe: "Ajouter un employé",
    contract_management: "Gestion des contrats",
    validator_management: "Gestion des validateurs",
    edit_user: "Modifier un utilisateur",
    entity_management: "Gestion des entités",
    link_counter: "Lier un compteur à l'utilisateur",
    add_profil: "Ajouter un profil",
    edit_profil: "Modifier un profil",
    add_payment: "Ajouter un paiement",
    edit_checking_rules: "Définir les règles de pointage",

    // Planning
    DASHBOARD: "Dashboard",
    DASHBOARD_MENU: "Accès menu 'Dashboard'",

    PLANNING: "Planning",
    PLANNING_MENU: "Accès menu 'Planning'",

    DEMAND_VALIDATION: "Accès menu 'Demandes et validations'",
    DAILY_FOLLOW_UP: "Accès menu 'Suivi quotidien'",

    // Functions
    add_leaves: "Faire une demande",
    edit_my_planning: "Editer mon planning",
    edit_real: "Modifier le réalisé",
    see_others_planning: "Voir les autres plannings",
    see_team_planning: "Voir les plannings d'équipe",
    edit_others_planning: "Editer les autres plannings",
    force_planning_hour_limit: "Forcer le dépassement des limites d'heures",
    see_my_checking: "Voir les pointages personnels",
    see_others_checking: "Voir les autres pointages",
    others_planning_level: "Niveau de vue des autres plannings",
    team_planning_level: "Niveau de vue des plannings d'équipe",

    // Manifestations
    admin_view: "Vue administrateur des évènements",

    // Gestion des tâches et planification
    TASK: "Gestion des interventions",
    TASK_LIST: "Liste des interventions",
    TASK_PLANNING: "Planning",
    TASK_EXPORT: "Statistiques",
    // function
    task_create: "Création d'une intervention",
    task_enroll: "Prise en charge d'une intervention",
    task_force_enroll: "Définir l'attribution d'une intervention",

    // Notes de frais
    NOTES: "Notes de frais",
    NOTES_MY: "Accès menu 'Mes notes de frais'",
    NOTES_MANAGE: "Accès menu 'Gestion des notes' (validation)",

    // Gestion des talents
    TALENT: "Gestion des talents",
    TALENT_DASHBOARD: "Accès menu 'Dashboard'",
    TALENT_COLLABORATEURS: "Accès menu 'Collaborateurs'",
    TALENT_RECRUTEMENT: "Accès menu 'Recrutement'",
    TALENT_ENTRETIENS: "Accès menu 'Entretiens'",
    TALENT_FORMATIONS: "Accès menu 'Formations'",
}